$(document).ready(function () {

    $("#exchange-balance").attr('disabled', true);
    ocultarPanel();

    //$(".wallet-original").change(function () {
    $('.wallet-original').blur(function () {

        if (!$(this).val()) return;

        let url = window.location.origin + '/get-data-wallet'
        let formData = new FormData();
        formData.append('num_card', $(this).val());
        formData.append('type', $('#tipo').val());
        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                if (response.success != 'true') {
                    Swal.fire('Advertencia', response.msg, 'error');
                    $(".show-data-wallet-original").hide();
                    $("#exchange-balance").attr('disabled', true);
                    return false;
                }

                $.each(response, function (key, value) {
                    $("." + key + "").html(value);
                });

                if (response.amount == 0) {
                    Swal.fire('Advertencia', 'El monto del monedero origen debe ser mayor a 0', 'error');
                }

                $(".amount_input").val(response['amount']);
                $(".show-data-wallet-original").show();
                $(".show-data-wallet-resultado").hide();

            })
            .fail(function (jqXHR, textStatus) {
                ResponseFail(jqXHR);
            });
    });

    //$(".wallet-destino").change(function () {
    $('.wallet-destino').blur(function () {

        if (!$(this).val()) return;

        let url = window.location.origin + '/get-data-wallet'
        let formData = new FormData();
        formData.append('num_card', $(this).val());
        formData.append('type', $('#tipo').val());

        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                if (response.success != 'true') {
                    Swal.fire('Advertencia', response.msg, 'error');
                    $(".show-data-wallet-destino").hide();
                    $("#exchange-balance").attr('disabled', true);
                    return false;
                }

                $.each(response, function (key, value) {
                    $("." + key + "_destino").html(value);
                });

                $(".show-data-wallet-destino").show();

                /*
                if (response.amount == 0) {
                    Swal.fire('Advertencia', 'El monto del monedero origen debe ser mayor a 0', 'error');
                }
                */

                let amount = getAmount($(".amount_input").val())

                if (amount > 0) {

                    $("#exchange-balance").attr('disabled', false);
                    return true;
                }
                $(".exchange-balance").attr('disabled', true);

            })
            .fail(function (jqXHR, textStatus) {
                ResponseFail(jqXHR);
            });

    });

    $(document).on('click', '#exchange-balance', function (e) {
        e.preventDefault();

        let wallet1 = $(".wallet-original").val();
        let wallet2 = $(".wallet-destino").val();

        if (wallet1 == wallet2) {
            Swal.fire('Advertencia', 'Ambos monederos son iguales, favor de revisar', 'error')
                .then((result) => {
                    return false;
                });
        } else {

            Swal
                .fire({
                    title: "¿ Esta seguro de hacer la operación ?",
                    //text: "Confirmar",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonText: "Sí, confirmar",
                    cancelButtonText: "Cancelar",
                    customClass: {
                        confirmButton: 'laproveedora_btn'
                    }
                })
                .then((resultado) => {
                    if (resultado.isConfirmed) {
                        Swal.fire({
                            title: 'Ingresar el motivó de cambio de monedero',
                            input: 'text',
                            inputAttributes: {
                                autocapitalize: 'off',
                                required: 'true'
                            },
                            showCancelButton: true,
                            confirmButtonText: 'Aceptar',
                            cancelButtonText: "Cancelar",
                            showLoaderOnConfirm: true,
                            customClass: {
                                confirmButton: 'laproveedora_btn',
                                popup: 'large-swal-modal'

                            },
                            preConfirm: (mensaje) => {
                                if (mensaje.length < 15) {
                                    Swal.showValidationMessage('El motivó debe tener al menos 15 caracteres')
                                }
                                if (mensaje.length > 150) {
                                    Swal.showValidationMessage('El motivó no debe exceder mas de 150 caracteres')
                                }
                                motivo = mensaje;
                            },
                            allowOutsideClick: () => !Swal.isLoading()
                        }).then((result) => {
                            if (result.isConfirmed) {
                                togglePreloader();
                                if (resultado.value) {

                                    let url = window.location.origin + '/update-balance'
                                    let formData = new FormData();
                                    formData.append('numCardOriginal', $(".wallet-original").val());
                                    formData.append('numCardDestino', $(".wallet-destino").val());
                                    formData.append('amount', $(".amount_input").val());
                                    formData.append('description', motivo)
                                    formData.append('type', $('#tipo').val());

                                    $.ajax({
                                        data: formData,
                                        url: url,
                                        type: 'POST',
                                        contentType: false,
                                        processData: false,
                                        headers: {
                                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                        }
                                    })
                                        .done(function (response) {

                                            togglePreloader();
                                            if (response.msg != "false") {
                                                $.each(response.data, function (key, value) {
                                                    $("." + key + "_resultado").html(value);
                                                });
                                                Swal.fire({
                                                    title: 'Completado',
                                                    text: response.msg,
                                                    icon: 'success',
                                                    confirmButtonText: 'Aceptar',
                                                    customClass: {
                                                        confirmButton: 'laproveedora_btn',

                                                    },
                                                });

                                                $(".exchange-balance").attr('disabled', true);
                                                $(".show-data-wallet-resultado").show();
                                                return true;
                                            }
                                            Swal.fire('Advertencia', response.msg, 'error');

                                        })
                                        .fail(function (jqXHR, textStatus) {
                                            ResponseFail(jqXHR);
                                        });

                                }
                            }
                        });
                    }
                });
        }

    });

    function getAmount(amount) {
        amount = amount.replace(/,/g, '');
        return parseFloat(amount);
    }

    function ocultarPanel() {
        $(".show-data-wallet-original").hide();
        $(".show-data-wallet-destino").hide();
        $(".show-data-wallet-resultado").hide();
        $(".wallet-original").val('');
        $(".wallet-destino").val('');
    }

    $(".wallet-original, .wallet-destino").on("keypress", function (event) {
        if (!validarInputNumerico(event)) {
            event.preventDefault(); // Evitar que se ingrese el carácter no válido
        }
    });

    function validarInputNumerico(event) {

        var codigoTecla = event.which ? event.which : event.keyCode;

        // Permitir solo números y algunas teclas especiales
        if (
            (codigoTecla >= 48 && codigoTecla <= 57) || // Números del 0 al 9
            codigoTecla === 8 || // Backspace
            //codigoTecla === 46 || // Punto decimal
            codigoTecla === 37 || // Flecha izquierda
            codigoTecla === 39 || // Flecha derecha
            codigoTecla === 35 || // Fin
            codigoTecla === 36 // Inicio
        ) {
            return true;
        } else {
            return false;
        }
    }

});



